// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__3cUGA","total":"Cart_total__2HiOu","actions":"Cart_actions__1wENW","button--alt":"Cart_button--alt__1cCAg","button":"Cart_button__3zlbE"};